
function getUrl(path) {
  return `//netcn.console.aliyun.com/core/${path}`;
}

export default class Service {

  constructor(request) {
    this.request = request;
  }

  async getList(opts) {
    const url = getUrl('shoppingcart/newgetall');
    const list = await this.request.send(url, null,
      { loading: false, ...opts });
    return list.map(item => {
      return {
        name: item.userInput.c_productDesc,
        value: item.relatedName,
        type: item.userInput.classID,
        period: item.periodNum
      };
    });
  }

  async add(item, opts) {
    const params = {
      relatedName: item.value,
      classID: item.type,
      periodNum: item.period
    };
    const url = getUrl('domainbuy/newshopcartadd');
    return this.request.send(url, params, opts);
  }

  async remove(item, opts) {
    const params = {
      relatedName: item.value,
      classID: item.type,
      periodNum: item.period
    };
    const url = getUrl('shoppingcart/newdelete');
    return this.request.send(url, params, opts);
  }

}


// WEBPACK FOOTER //
// ./src/cart/service.js